import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import * as Cesium from 'cesium';
// Dashed leader line from the comment pin on the map to the popover that's
// floating above it. Stays in sync as the user pans/zooms (pin screen
// position changes) and as the user drags the popover. SVG renders full-
// viewport with `pointer-events: none` so it never steals input.
export const PopoverLeaderLine = ({ viewer, anchor, popoverPos, popoverWidth, popoverHeight, }) => {
    const [pinScreen, setPinScreen] = useState(null);
    useEffect(() => {
        if (!viewer || viewer.isDestroyed())
            return;
        const world = Cesium.Cartesian3.fromDegrees(anchor.longitude, anchor.latitude, anchor.height);
        const recompute = () => {
            if (viewer.isDestroyed())
                return;
            const win = Cesium.SceneTransforms.worldToWindowCoordinates(viewer.scene, world);
            if (!win) {
                setPinScreen(null);
                return;
            }
            setPinScreen({ x: win.x, y: win.y });
        };
        recompute();
        const remove = viewer.scene.postRender.addEventListener(recompute);
        return () => {
            remove();
        };
    }, [viewer, anchor.latitude, anchor.longitude, anchor.height]);
    if (!pinScreen)
        return null;
    // Attach point = the closest point on the popover's bounding rectangle
    // to the pin. As the user drags the popover around, the attach slides
    // continuously along the perimeter — no L/R-edge snap, no fixed top
    // attachment that would slice through the popover when it sits below
    // the pin.
    const popoverRight = popoverPos.x + popoverWidth;
    const popoverBottom = popoverPos.y + popoverHeight;
    // If the pin's screen position is inside the popover's bbox, there's no
    // meaningful "leader" to draw — the popover already covers the pin.
    const insideX = pinScreen.x >= popoverPos.x && pinScreen.x <= popoverRight;
    const insideY = pinScreen.y >= popoverPos.y && pinScreen.y <= popoverBottom;
    if (insideX && insideY)
        return null;
    const attachX = Math.min(Math.max(pinScreen.x, popoverPos.x), popoverRight);
    const attachY = Math.min(Math.max(pinScreen.y, popoverPos.y), popoverBottom);
    return (_jsx("svg", { className: "fixed inset-0", style: {
            pointerEvents: 'none',
            width: '100vw',
            height: '100vh',
            zIndex: 1199, // just under the popover (1200)
        }, children: _jsx("line", { x1: pinScreen.x, y1: pinScreen.y, x2: attachX, y2: attachY, stroke: "rgba(238, 233, 225, 0.6)", strokeWidth: 1.5, strokeDasharray: "4 4", strokeLinecap: "round" }) }));
};
